// removed by extract-text-webpack-plugin
module.exports = {"Disclaimer":"Disclaimer__Disclaimer___3EeaY","DisclaimerIcon":"Disclaimer__DisclaimerIcon___BCCPp","DisclaimerText":"Disclaimer__DisclaimerText___2o4I4","DisclaimerToast":"Disclaimer__DisclaimerToast___2OqMJ","DisclaimerToastIcon":"Disclaimer__DisclaimerToastIcon___3YTVp","DisclaimerContent":"Disclaimer__DisclaimerContent___1rW6s"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/Disclaimer/Disclaimer.less
// module id = 1140
// module chunks = 0 1